import { render } from "./BookingButton.vue?vue&type=template&id=325aad52"
import script from "./BookingButton.vue?vue&type=script&lang=js"
export * from "./BookingButton.vue?vue&type=script&lang=js"

import "./BookingButton.vue?vue&type=style&index=0&id=325aad52&lang=scss"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__